(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chatbot-support-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';
    
    // Only run on desktop homepage
    function isHomepage() {
      return window.location.pathname === '/' || window.location.pathname === '/index';
    }
    
    function isDesktop() {
      return window.innerWidth >= 750;
    }
    
    function updateSupportBarVisibility() {
      const supportBar = document.getElementById('chatbotSupportBar');
      if (!supportBar) return;
      
      // If not desktop or not homepage, always show support bar
      if (!isDesktop() || !isHomepage()) {
        supportBar.style.display = 'block';
        return;
      }
      
      // On desktop homepage, check scroll position relative to ceel-hero-slideshow
      const heroSlideshow = document.querySelector('.ceel-hero-slideshow');
      const heroContent = document.querySelector('.ceel-hero-slideshow__content');
      if (!heroSlideshow || !heroContent) {
        // No hero section found, show support bar
        supportBar.style.display = 'block';
        return;
      }
      
      // Get hero slideshow container dimensions (it's 100vh)
      const heroRect = heroSlideshow.getBoundingClientRect();
      const heroHeight = heroRect.height;
      const heroTop = heroSlideshow.offsetTop;
      const scrollPosition = window.scrollY || window.pageYOffset;
      
      // Calculate how much we've scrolled past the top of hero section
      const scrollPastHero = Math.max(0, scrollPosition - heroTop);
      
      // Calculate scroll percentage (30% of hero height)
      const threshold = heroHeight * 0.3;
      
      // Show support bar if scrolled at least 30% of hero height past hero section
      if (scrollPastHero >= threshold) {
        supportBar.style.display = 'block';
      } else {
        supportBar.style.display = 'none';
      }
    }
    
    // Initial check
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(updateSupportBarVisibility, 100);
      });
    } else {
      setTimeout(updateSupportBarVisibility, 100);
    }
    
    // Update on scroll (throttled)
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        cancelAnimationFrame(scrollTimeout);
      }
      scrollTimeout = requestAnimationFrame(updateSupportBarVisibility);
    }, { passive: true });
    
    // Update on resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      if (resizeTimeout) {
        clearTimeout(resizeTimeout);
      }
      resizeTimeout = setTimeout(updateSupportBarVisibility, 150);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
